/**
 * Create Duel HTTP Service
 *
 * Calls the create-duel endpoint to initiate a new duel.
 */

import { apiRequest } from "@/services/api-client";
import { CreateDuelInput, CreateDuelOutput, WebAppRoutes } from "types/web-app";

/**
 * Create a new duel between the authenticated player and an opponent
 */
export const createDuel = (input: CreateDuelInput) =>
  apiRequest<CreateDuelOutput>("/" + WebAppRoutes.CREATE_DUEL, {
    method: "POST",
    body: JSON.stringify(input),
  });
